// src/components/currencies/Table/CurrenciesTableColumns.jsx

const CurrenciesTableColumns = [
    { id: "name", labelAr: "الاسم", labelEn: "Name", sortable: true },
    { id: "code", labelAr: "الكود", labelEn: "Code", sortable: true },
    { id: "symbol", labelAr: "الرمز", labelEn: "Symbol", sortable: true },
    { id: "exchange_rate", labelAr: "سعر الصرف", labelEn: "Exchange Rate", sortable: false },
    { id: "is_default", labelAr: "افتراضي", labelEn: "Default", sortable: false },
    { id: "status", labelAr: "الحالة", labelEn: "Status", sortable: false },
];

export default CurrenciesTableColumns;
